import React, { createContext, useState, useContext } from 'react';
import { node } from 'prop-types';
import {
  getKitchenByZipCode,
  waitListFoundingApi,
  reportUiBugApi,
} from './api-services/kitchen.service';
import { createFutureCustomer } from './api-services/customer.service';
import { localStorageKeys } from '../global/constants';

const {
  ZIP_CODE,
  KITCHEN_NAMES,
  KITCHEN_API_FETCHED_TIME,
  MANAGING_BRANCH_NAME,
  VISITED_COUNT,
  ZIPCODE_GEO_COORDINATES,
} = localStorageKeys;
export const StoreHeaderDataContext = createContext();

const StoreHeaderDataProvider = ({ children }) => {
  const [emailForFutureCustomer, setEmailForFutureCustomer] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  // Setting falg to display header ,can use for anything ,currently we are using in FirstTimeCheckerMobile component
  const [HeaderVisibility, setHeaderVisibility] = useState(true);
  // Tabs Context
  const [activeHeader, setActiveHeader] = useState('');

  //state used in zipcodeform.jsx and DeliveryAddress.jsx
  const [zipcode, setZipcode] = useState('');
  const [isDeliverable, setIsDeliverable] = useState(
    !!(localStorage.getItem(ZIP_CODE) && localStorage.getItem(KITCHEN_NAMES))
  );

  // kitchen by zipcode api call
  const [kitchensByZipcode, setKitchensByZipcode] = useState({
    zipcode: localStorage.getItem(ZIP_CODE),
    loading: false,
    success: true,
    zipCodeData: {}, // zipcode keys with value as array of kitchens for ex: { 60076: [kitchen1,...], 45623: [kitchen1, ...]}
    // noZipCodeData: [], // array for zipcodes which don't have data
    error: '',
    totalKitchens: 0,
    data: null,
  });

  const [kitchensByZipcodeResponse, setKitchensByZipcodeResponse] = useState({
    payloadZipcode: null,
    isloading: false,
    data: null,
    success: null,
    message: null,
    totalKitchens: 0,
    zipCodeData: {},
  });

  const [waitListResponse, setWaitListResponse] = useState({
    isloading: false,
    data: null,
    success: null,
    message: null,
  });

  const [reportUiBugResponse, setReportUiBugResponse] = useState({
    isloading: false,
    data: null,
    success: null,
    message: null,
  });

  const clearZipcodeFromLocalStorage = async () => {
    await setKitchensByZipcode({
      ...kitchensByZipcode,
      success: true,
      zipcode: undefined,
      totalKitchens: 0,
    });
    localStorage.removeItem(ZIP_CODE);
    localStorage.removeItem(KITCHEN_NAMES);
    localStorage.removeItem(KITCHEN_API_FETCHED_TIME);
    localStorage.removeItem(MANAGING_BRANCH_NAME);
    localStorage.removeItem(ZIPCODE_GEO_COORDINATES);
    // localStorage.removeItem(VISITED_COUNT);
    setIsDeliverable(false);
  };

  /**
   * local storage will be checked (to avoid unnecessry API calls) only in APPLY button click scenario
   *  it won't be checked in onBlur handler
   * @param {*} zipcode
   * @param {*} setLocalStorage
   */
  const onGetKitchenByZipcode = async (zipcode, setLocalStorage = true, makeApiCall = false) => {
    // if (kitchensByZipcode.noZipCodeData.indexOf(`${zipcode}`) >= 0 || localStorage.getItem(ZIP_CODE) === zipcode) {
    try {
      if (setLocalStorage && !makeApiCall && localStorage.getItem(ZIP_CODE) === zipcode) {
        console.log('do nothing');
      } else if (!kitchensByZipcode.zipCodeData[zipcode]) {
        await setKitchensByZipcode({
          ...kitchensByZipcode,
          loading: true,
          error: '',
          totalKitchens: 0,
        });
        const response = await getKitchenByZipCode(zipcode);
        if (response) {
          if (!response.hasError) {
            await setKitchensByZipcode({
              ...kitchensByZipcode,
              ...response,
              loading: false,
              success: response.data.success,
              zipCodeData: {
                ...kitchensByZipcode.zipCodeData,
                ...response.data.kitchens,
              },
              error: '',
              totalKitchens: 0,
            });

            if (response.data?.success) {
              if (response.data?.totalKitchens > 0) {
                await setKitchensByZipcode({
                  ...kitchensByZipcode,
                  zipcode,
                  error: '',
                  totalKitchens: response.data.totalKitchens,
                  zipCodeData: {
                    ...kitchensByZipcode.zipCodeData,
                    ...response.data.kitchens,
                  },
                  data: response.data,
                });
                if (setLocalStorage) {
                  await localStorage.setItem(
                    KITCHEN_API_FETCHED_TIME,
                    response?.data?.fetchApiTime
                  );
                  await localStorage.setItem(ZIP_CODE, `${zipcode}`);
                  await localStorage.setItem(
                    ZIPCODE_GEO_COORDINATES,
                    `${response?.data?.geolocation?.coordinates}`
                  );

                  // Add Zipcode GeoCoordinates to local storage
                  await localStorage.setItem(
                    MANAGING_BRANCH_NAME,
                    response?.data?.managing_branch_name
                  );
                  await localStorage.setItem(KITCHEN_NAMES, `${response.data.kitchens[zipcode]}`);

                  setIsDeliverable(true);
                  return response?.data;
                }
              } else {
                // VALIDATE EMAIL
                // Send Data to FUTURE CUSTOMER API
                if (emailForFutureCustomer && emailForFutureCustomer.length > 0) {
                  createFutureCustomer({
                    email: emailForFutureCustomer,
                    firstName,
                    lastName,
                    zipcode,
                    manual_notes: 'subscriptionSignUp',
                  });
                }
                await setKitchensByZipcode({
                  ...kitchensByZipcode,
                  // zipcode: null,
                  success: false,
                  error: '',
                  totalKitchens: 0,
                });
              }
            } else {
              console.log('zipcode error', response.data?.ErrorMessage);
              if (
                response.data &&
                response.data.ErrorMessage.indexOf('No Record Found in Database') > -1
              ) {
                if (emailForFutureCustomer && emailForFutureCustomer.length > 0) {
                  createFutureCustomer({
                    email: emailForFutureCustomer,
                    firstName,
                    lastName,
                    zipcode,
                    manual_notes: 'subscriptionSignUp',
                  });
                }
              }
              setKitchensByZipcode({
                ...kitchensByZipcode,
                ...response,
                loading: false,
                success: false,
                // noZipCodeData: [...kitchensByZipcode.noZipCodeData, zipcode],
                error: '',
              });
            }
          } else {
            await setKitchensByZipcode({
              ...kitchensByZipcode,
              loading: false,
              error: response.message,
              hasError: response.hasError,
            });
          }
        } else {
          await setKitchensByZipcode({
            ...kitchensByZipcode,
            loading: false,
            error: 'Network Error',
            hasError: true,
          });
        }
      } else {
        console.log('seting zipconde', zipcode);
        await localStorage.setItem(ZIP_CODE, `${zipcode}`);
      }
    } catch (error) {
      console.log('Catch block onGetKitchenByZipcode', error);
    }
  };

  // I have to rewrite this GetKitchenByZipcode method which i am using in onCustomerInformationApiHandler() [LoginDataProvider.jsx]
  const onGetKitchenByZipcodeHandler = async (zipcode, setLocalStorage = true) => {
    try {
      setKitchensByZipcodeResponse({
        payloadZipcode: zipcode,
        isloading: true,
        data: null,
        success: null,
        message: null,
        totalKitchens: 0,
        zipCodeData: {},
      });
      const response = await getKitchenByZipCode(zipcode);
      if (response.hasError) {
        await setKitchensByZipcodeResponse({
          payloadZipcode: zipcode,
          isloading: false,
          data: null,
          success: !response.hasError,
          message: response.message,
          totalKitchens: 0,
          zipCodeData: {},
        });
        return;
      }

      if (response?.data?.success) {
        setKitchensByZipcodeResponse({
          payloadZipcode: zipcode,
          isloading: false,
          data: response.data,
          success: response.data.success,
          message:
            response.data?.ErrorMessage || response.data?.CustomMessage || response.data?.message,
          totalKitchens: response.data.totalKitchens,
          zipCodeData: {
            ...kitchensByZipcode.zipCodeData,
            ...response.data.kitchens,
          },
        });
        // set to local storage
        if (response?.data?.totalKitchens !== 0) {
          if (setLocalStorage) {
            await localStorage.setItem(KITCHEN_API_FETCHED_TIME, response?.data?.fetchApiTime);
            await localStorage.setItem(ZIP_CODE, `${zipcode}`);
            await localStorage.setItem(MANAGING_BRANCH_NAME, response?.data?.managing_branch_name); //
            await localStorage.setItem(KITCHEN_NAMES, `${response.data.kitchens[zipcode]}`);
            setIsDeliverable(true);
          }
        } else {
          setIsDeliverable(false);
          localStorage.clear();
        }
        return response;
      }

      if (response.data?.success === false) {
        setKitchensByZipcodeResponse({
          payloadZipcode: zipcode,
          isloading: false,
          data: response.data,
          success: response.data.success,
          message:
            response.data?.ErrorMessage || response.data?.CustomMessage || response.data?.message,
          totalKitchens: 0,
          zipCodeData: {},
        });

        return;
      }
    } catch (error) {
      console.log(' catch block for onGetKitchenByZipcodeHandler', error);
      setKitchensByZipcodeResponse({
        payloadZipcode: null,
        data: null,
        isLoading: false,
        message: error,
        success: false,
        totalKitchens: 0,
        zipCodeData: {},
      });
    }
  };

  // WaitList Founding Member API call

  const onWaitListFounderHandler = async (payload) => {
    try {
      setWaitListResponse({
        isloading: true,
        data: null,
        success: null,
        message: null,
      });
      const response = await waitListFoundingApi(payload);
      if (response.hasError) {
        await setWaitListResponse({
          isloading: false,
          data: null,
          success: !response.hasError,
          message:
            response.data?.ErrorMessage || response.data?.customMessage || response.data?.message,
        });
        return;
      }

      if (response?.data?.success) {
        setWaitListResponse({
          isloading: false,
          data: response.data,
          success: response.data.success,
          message:
            response.data?.ErrorMessage || response.data?.customMessage || response.data?.message,
        });

        return response;
      }

      if (response.data?.success === false) {
        setWaitListResponse({
          isloading: false,
          data: response.data,
          success: response.data.success,
          message:
            response.data?.ErrorMessage || response.data?.customMessage || response.data?.message,
        });

        return response;
      }
    } catch (error) {
      console.log('catch block for onWaitListFounderHandler', error);
      setWaitListResponse({
        data: null,
        isLoading: false,
        message: error,
        success: false,
      });
    }
  };

  const onReportUiBugCustomer = async (payload) => {
    try {
      setReportUiBugResponse({
        isloading: true,
        data: null,
        success: null,
        message: null,
      });
      const response = await reportUiBugApi(payload);
      if (response.hasError) {
        await setReportUiBugResponse({
          isloading: false,
          data: null,
          success: !response.hasError,
          message:
            response.data?.ErrorMessage || response.data?.customMessage || response.data?.message,
        });
        return;
      }

      if (response?.data?.success) {
        setReportUiBugResponse({
          isloading: false,
          data: response.data,
          success: response.data.success,
          message:
            response.data?.ErrorMessage || response.data?.customMessage || response.data?.message,
        });

        return response;
      }

      if (response.data?.success === false) {
        setReportUiBugResponse({
          isloading: false,
          data: response.data,
          success: response.data.success,
          message:
            response.data?.ErrorMessage || response.data?.customMessage || response.data?.message,
        });

        return response;
      }
    } catch (error) {
      console.log('catch block for onReportUiBugCustomer', error);
      setReportUiBugResponse({
        data: null,
        isLoading: false,
        message: error,
        success: false,
      });
    }
  };

  return (
    <StoreHeaderDataContext.Provider
      value={{
        kitchensByZipcode,
        setKitchensByZipcode,
        activeHeader,
        setActiveHeader,
        clearZipcodeFromLocalStorage,
        onGetKitchenByZipcode,
        zipcode,
        setZipcode,
        setEmailForFutureCustomer,
        setFirstName,
        setLastName,
        isDeliverable,
        setIsDeliverable,
        HeaderVisibility,
        setHeaderVisibility,
        onGetKitchenByZipcodeHandler,
        setKitchensByZipcodeResponse,
        kitchensByZipcodeResponse,
        onWaitListFounderHandler,
        setWaitListResponse,
        waitListResponse,
        onReportUiBugCustomer,
        reportUiBugResponse,
        setReportUiBugResponse,
      }}
    >
      {children}
    </StoreHeaderDataContext.Provider>
  );
};

StoreHeaderDataProvider.propTypes = {
  children: node.isRequired,
};

export default StoreHeaderDataProvider;
